import { Switch } from "@headlessui/react";
import ClassNames from "Helpers/Common";

export const Toggle = ({ enabled = false, onChange, disabled = false }) => {
  return (
    <Switch
      checked={enabled}
      disabled={disabled}
      onChange={() => onChange?.()}
      className={ClassNames(
        enabled ? "bg-blue-chill" : "bg-gray-200",
        disabled && "opacity-50 cursor-not-allowed",
        "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
      )}
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className={ClassNames(
          enabled ? "translate-x-5" : "translate-x-0",
          "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
        )}
      />
    </Switch>
  );
};
